// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"311":"70c02776","353":"eb3197ca"}[chunkId] + ".chunk.css";
};